import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "jsoncontentschemadata"
    }}>{`JsonContentSchemaData`}</h1>
    <p>{`Represents the proposition response object containing a `}<inlineCode parentName="p">{`json-content`}</inlineCode>{` schema.`}</p>
    <h2 {...{
      "id": "ios-interface"
    }}>{`iOS Interface`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`@objc(AEPJsonContentSchemaData)
@objcMembers
public class JsonContentSchemaData: NSObject, Codable {
    /// Represents the content of the JsonContentSchemaData object.  Its value's type is determined by \`format\`.
    public let content: Any
    
    /// Determines the value type of \`content\`.
    public let format: ContentType?

    ...
}
`}</code></pre>
    <h2 {...{
      "id": "android-interface"
    }}>{`Android Interface`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public class JsonContentSchemaData implements SchemaData {
    private Object content = null;
    private ContentType format = null;

    @Override
    @Nullable public Object getContent() { return content; }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      